module.exports = __webpack_public_path__ + "static/media/hangman_5.9148b31b.svg";